import React, { Component } from 'react';

class Add extends Component {
    render() {
        return (
            <svg width="24" height="24" viewBox="0 0 100 100">
                <path id="a" d="M 35.00,13.16
                               C 35.00,13.16 84.00,13.16 84.00,13.16
                                 95.98,13.02 97.98,15.02 98.00,27.00
                                 98.00,27.00 98.00,67.00 98.00,67.00
                                 98.00,71.16 98.73,79.51 96.26,82.77
                                 93.53,86.39 89.03,85.99 85.00,86.00
                                 85.00,86.00 23.00,86.00 23.00,86.00
                                 17.99,86.00 5.88,87.45 3.02,82.77
                                 1.80,80.77 2.00,77.31 2.00,75.00
                                 2.00,75.00 2.00,24.00 2.00,24.00
                                 2.03,17.97 1.70,15.42 8.02,13.16
                                 8.02,13.16 35.00,13.16 35.00,13.16 Z
                               M 19.00,18.00
                               C 16.46,18.00 9.45,17.56 7.60,19.02
                                 5.62,20.59 6.00,24.70 6.00,27.00
                                 6.00,27.00 6.00,74.00 6.00,74.00
                                 6.14,81.49 8.26,80.99 15.00,81.00
                                 15.00,81.00 47.00,81.00 47.00,81.00
                                 47.00,81.00 47.00,18.00 47.00,18.00
                                 47.00,18.00 19.00,18.00 19.00,18.00 Z
                               M 80.00,81.00
                               C 82.54,81.00 89.55,81.44 91.40,79.98
                                 93.38,78.41 93.00,74.30 93.00,72.00
                                 93.00,72.00 93.00,25.00 93.00,25.00
                                 92.86,17.51 90.74,18.01 84.00,18.00
                                 84.00,18.00 52.00,18.00 52.00,18.00
                                 52.00,18.00 52.00,81.00 52.00,81.00
                                 52.00,81.00 80.00,81.00 80.00,81.00 Z
                               M 80.00,27.00
                               C 85.05,27.03 87.04,26.55 88.00,32.00
                                 88.00,32.00 57.00,32.00 57.00,32.00
                                 57.00,32.00 57.00,27.00 57.00,27.00
                                 57.00,27.00 80.00,27.00 80.00,27.00 Z
                               M 88.00,37.00
                               C 88.00,37.00 88.00,42.00 88.00,42.00
                                 88.00,42.00 57.00,42.00 57.00,42.00
                                 57.00,42.00 57.00,37.00 57.00,37.00
                                 57.00,37.00 88.00,37.00 88.00,37.00 Z
                               M 88.00,47.00
                               C 88.00,47.00 88.00,52.00 88.00,52.00
                                 88.00,52.00 57.00,52.00 57.00,52.00
                                 57.00,52.00 57.00,47.00 57.00,47.00
                                 57.00,47.00 88.00,47.00 88.00,47.00 Z
                               M 88.00,57.00
                               C 88.00,57.00 88.00,62.00 88.00,62.00
                                 88.00,62.00 57.00,62.00 57.00,62.00
                                 57.00,62.00 57.00,57.00 57.00,57.00
                                 57.00,57.00 88.00,57.00 88.00,57.00 Z
                               M 88.00,67.00
                               C 88.00,67.00 88.00,72.00 88.00,72.00
                                 88.00,72.00 57.00,72.00 57.00,72.00
                                 57.00,72.00 57.00,67.00 57.00,67.00
                                 57.00,67.00 88.00,67.00 88.00,67.00 Z"/>
            </svg>
        );
    }
}

export default Add;



// WEBPACK FOOTER //
// ./src/icons/Book.js